export class LocalizationStringApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLocalizationStrings({ languageCode, posConfigurationId, category, signal }) {
    return this.#http.get('/api/localization/strings', {
      params: { languageCode, posConfigurationId, category },
      signal,
    });
  }

  async updateLocalizationString({ id, ...body }) {
    return this.#http.put(`/api/localization/strings/${id}`, body);
  }

  async deleteLocalizationString({ id }) {
    return this.#http.delete(`/api/localization/strings/${id}`);
  }
}
